import { foundationProgressStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { SecondaryRapidColorHEX } from '../_common/colors.hex';
export const zeroProgressStyles = (context, definition) => css `
  ${foundationProgressStyles(context, definition)}
  :host([appearance="secondary-teal"]) {
    --accent-foreground-rest: ${SecondaryRapidColorHEX.teal};
  }

  :host([appearance='secondary-orange']) {
    --accent-foreground-rest: ${SecondaryRapidColorHEX.orange};
  }
`;
